import { Header } from '@app/navigation/header';
import { Body, Body5, Container, Page } from '@ui';
import React from 'react';
import styled from 'styled-components';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router';

const PageWrapper = styled.div``;
const BodyWrapper = styled.div`
  padding: 24px;
`;

export function PageError({ message }) {
  const navigate = useNavigate();

  const onGoBack = () => {
    navigate(ROUTES.home);
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>
          <Page>
            <BackArrowButton onClick={onGoBack} />
            <Container top={48} bottom={24}>
              <Body5>{message || 'Something went wrong. Please try again.'}</Body5>
            </Container>
          </Page>
        </BodyWrapper>
      </Body>
    </PageWrapper>
  );
}
